import * as React from 'react'
import { PageResult } from '../pageDirectory'
import {
    getRecentQueries,
    getRecentResults,
    RecentResult,
    saveRecentQuery,
    saveRecentResult,
    saveRecentView,
} from '../recentSearches'
import { SearchResult } from '../schema'

// Recently opened results and searched queries for the active account,
// reloaded each time the overlay opens.
export const useRecentResults = (accountSlug: string | null, isOpen: boolean) => {
    const [recentResults, setRecentResults] = React.useState<RecentResult[]>([])
    const [recentQueries, setRecentQueries] = React.useState<string[]>([])

    React.useEffect(() => {
        if (isOpen) {
            setRecentResults(accountSlug ? getRecentResults(accountSlug) : [])
            setRecentQueries(accountSlug ? getRecentQueries(accountSlug) : [])
        }
    }, [isOpen, accountSlug])

    const recordResult = (result: SearchResult, deeplink: string) => {
        if (accountSlug) {
            saveRecentResult(accountSlug, result, deeplink)
        }
    }

    const recordView = (page: PageResult) => {
        if (accountSlug) {
            saveRecentView(accountSlug, page)
        }
    }

    const recordQuery = (query: string) => {
        if (accountSlug) {
            saveRecentQuery(accountSlug, query)
        }
    }

    return { recentResults, recentQueries, recordResult, recordView, recordQuery }
}
